import { motion } from "framer-motion";

export const ease = [0.33, 1, 0.68, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, ease, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionLabel({ children }) {
  return (
    <span className="inline-block text-sm uppercase tracking-[0.28em] font-semibold text-saffron-600 mb-4">
      {children}
    </span>
  );
}

// Bhagwa Dhwaj (Hindu saffron flag) — used across the site
export function OmMark({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} xmlns="http://www.w3.org/2000/svg" aria-label="Bhagwa Dhwaj (saffron flag)">
      {/* Ball finial atop the pole */}
      <circle cx="14" cy="5" r="2.4" fill="currentColor" />
      {/* Vertical pole */}
      <rect x="12.5" y="6" width="3" height="54" rx="1.2" fill="currentColor" />
      {/* Saffron flag — pennant with V-cut on the flying edge */}
      <path d="M15.5 8 L52 8 L44 20 L52 32 L15.5 32 Z" fill="#EA580C" />
    </svg>
  );
}
